/* Plyr solo dove c'e' davvero un video.
 *
 * Importato staticamente costava ~110 KB di JS su OGNI pagina. I video stanno
 * nelle landing e nei contenuti con <oembed>, cioe' quasi da nessuna parte.
 */
let plyrPromise = null;

window.loadPlyr = function () {
    if (!plyrPromise) {
        plyrPromise = import("plyr").then((module) => {
            const Plyr = module.default ?? module;
            window.Plyr = Plyr;
            return Plyr;
        });
    }

    return plyrPromise;
};
